import { LoopReducer } from 'redux-loop'

import AERData from 'aer-data/src/index'

import { Action, State } from './types'

export const initialState: State = {
  ENG: AERData.normalizedData.ENG.friends,
  FR: AERData.normalizedData.FR.friends,
  PL: AERData.normalizedData.PL.friends,
  DE: AERData.normalizedData.DE.friends,
}

export const Reducer: LoopReducer<State, Action> = (
  state: State = initialState,
  action: Action
) => {
  switch (action.type) {
    default: {
      return state
    }
  }
}
